(() => {
  if (window.warrantyInfoPopupInitialized) return;
  window.warrantyInfoPopupInitialized = true;

  let activeModal = null;
  let activeTrigger = null;

  const closeModal = () => {
    if (!activeModal) return;

    activeModal.hidden = true;
    document.body.classList.remove('warranty-info-open');

    if (activeTrigger) {
      activeTrigger.setAttribute('aria-expanded', 'false');
      activeTrigger.focus();
    }

    activeModal = null;
    activeTrigger = null;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-warranty-info-open]');

    if (trigger) {
      const modal = document.getElementById(trigger.dataset.warrantyInfoOpen);
      if (!modal) return;

      if (activeModal && activeModal !== modal) closeModal();

      activeModal = modal;
      activeTrigger = trigger;
      modal.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('warranty-info-open');
      modal.querySelector('.warranty-info__close')?.focus();
      return;
    }

    if (event.target.closest('[data-warranty-info-close]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeModal) closeModal();
  });
})();
